import { Box, Grid, Skeleton } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import CustomerContext from "../../../context";
import InfiniteList from "./infinityList";
import TransactionHistory from "./list";
const Transactions = () => {
  const { transactionsRequest, getTransactions } = useContext(CustomerContext);

  const { data: transactions } = transactionsRequest;

  useEffect(() => {
    if (!transactions.length) getTransactions();
  }, []);

  return (
    <Box
      flex={1}
      sx={{
        height: "90dvh",
        overflowY: "auto",
        position: "relative",
        borderRadius: 4,
      }}
    >
      {/* <List  dense>
              {transactions.map((transaction, key) => (
                <TransactionComponent key={key} transaction={transaction} />
              ))}
            </List> */}
      <InfiniteList transactions={transactions} />
      <div style={{ height: 50 }}></div>
    </Box>
  );
};

const LoadingComponent = () => {
  return (
    <>
      {new Array(5).fill().map((e, k) => (
        <div key={k} style={{ marginTop: 10 }}>
          <Skeleton width={"100%"} height={30} />
          <Skeleton width={"100%"} height={20} />
          <Skeleton width={"100%"} height={20} />
        </div>
      ))}
    </>
  );
};

export default Transactions;
